const leftFillNum = (num: number, targetLength: number) => {
  return num.toString().padStart(targetLength, '0');
};

const getMinutesFromMS = (ms: number) => {
  return Math.floor(ms / (1000 * 60));
};

const getSecondsFromMS = (ms: number) => {
  const MINUTES_IN_MS = 1000 * 60;
  return Math.round((ms % MINUTES_IN_MS) / 1000);
};

export const formatMillisecondsToAudioTime = (ms: number) => {
  return (
    leftFillNum(getMinutesFromMS(ms), 2) +
    ':' +
    leftFillNum(getSecondsFromMS(ms), 2)
  );
};
